export default __webpack_public_path__ + "static/media/laptop_en.aee1edcb.png";